import PropTypes from 'prop-types';
import React from 'react';

import {
  IconButton,
  Menu,
  MenuItem,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core';
import {
  grey,
} from '@material-ui/core/colors';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import MoreVertIcon from '@material-ui/icons/MoreVert';


class AddressItem extends React.Component {

  static displayName = 'AddressItem';

  static propTypes = {
    address: PropTypes.object.isRequired,
    dataId: PropTypes.string,
    onDelete: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
  };

  state = {
    anchorEl: null,
  };

  render() {
    const {address, dataId, onDelete, onEdit, ...props} = this.props;
    return (
      <div data-id={dataId}>
        <ListItem {...props}>
            <ListItemIcon>
              <FavoriteBorderIcon />
            </ListItemIcon>
            <ListItemText
              data-id={'address-row-data'}
              primary={address.name}
              secondary={address.address}
            />
            <span hidden data-id={'address-row-id'}>{address.addressId}</span>
            <ListItemSecondaryAction>
              <IconButton
                aria-label="More"
                aria-haspopup="true"
                data-id={'address-row-kebab-button'}
                onClick={(event) => this.setState({anchorEl: event.currentTarget})}
              >
                <MoreVertIcon style={{fill: grey[500]}} />
              </IconButton>
              <Menu
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={() => this.setState({anchorEl: null})}
              >
                <div data-id={'kebab-menu-container'} >
                  <MenuItem
                    data-id={'edit-address'}
                    onClick={() => onEdit(address.addressId)}
                  >
                    Edit
                  </MenuItem>
                  <MenuItem
                    data-id={'delete-address'}
                    onClick={() => onDelete(address.addressId)}
                  >
                    Delete
                  </MenuItem>
                </div>
              </Menu>
            </ListItemSecondaryAction>
        </ListItem>
      </div>
    );
  }
}

export default AddressItem;



// WEBPACK FOOTER //
// ./src/ondemand/components/AddressList/AddressItem.js